/**
 * Which build this is.
 *
 * Substituted at build time from `version.json` at the repository root (see
 * `vite.config.ts`). The fallbacks matter: these identifiers do not exist when
 * a module is loaded outside a Vite build — a unit test, a Node script — and a
 * version readout is never worth throwing over.
 */
declare const __VERSION__: string;
declare const __BUILD__: number;
declare const __COMMIT__: string;
declare const __BUILT_AT__: string;

const read = <T>(f: () => T, fallback: T): T => {
  try { return f(); } catch { return fallback; }
};

export const VERSION = {
  /** Series plus build, e.g. `0.2.7`. What a player should quote. */
  label: read(() => __VERSION__, 'dev'),
  build: read(() => __BUILD__, 0),
  commit: read(() => __COMMIT__, ''),
  date: read(() => __BUILT_AT__, ''),
} as const;

/** One line for a footer: `v0.2.7 · 2026-09-21`. */
export const versionLine = (): string =>
  `v${VERSION.label}${VERSION.date ? ` · ${VERSION.date}` : ''}`;

/** The same, with the commit, for a bug report. */
export const versionDetail = (): string =>
  `v${VERSION.label}${VERSION.commit ? ` · ${VERSION.commit}` : ''}` +
  `${VERSION.date ? ` · built ${VERSION.date}` : ''}`;
